import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { ModalView } from "./modal-view/modal-view";
import { TitleChange } from './services/title-change';
import { Footer } from "./footer/footer";
import { LastUpdate } from './services/last-update';
import { NavActions } from './services/nav-actions';
import { Nav } from "./nav/nav";
import { NgClass } from "@angular/common";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ModalView, Footer, Nav, NgClass],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.scss'
})
export class App {
  titleSvc = inject(Title);
  metaSvc = inject(Meta);
  dynamicTitle = inject(TitleChange);
  lastUpdate = inject(LastUpdate);
  hideNav = inject(NavActions);
  
  constructor() {
    effect(async () => {
      this.titleSvc.setTitle(this.dynamicTitle.current());
      this.metaSvc.updateTag({
        name: 'description',
        content: this.dynamicTitle.currentDescription()
      });
      this.hideNav.toggle(true);
    });
  }
}
